import { PalletType } from "../../../../../api/types/generated-types";

export const palletTypeList = Object.values(PalletType);
